import React from 'react';
import { Form, Checkbox, Input, Select } from 'antd'

const InputGroup = Input.Group;
const { Option } = Select;

const sumaTotal = (lista, moneda) => {
    if (lista.length == 0) {
        return 0;
    } else {
        var total=lista.filter(e => e.idMoneda == moneda).reduce((a, b) => a + (b["montoCuota"] || 0), 0).toFixed(2);
        return total
    }
}

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-6"}>

            </div>
            <div className={"col-md-3"}>

            </div>
            <div className="col-md-3 pt-10">

                <div className="col text-right mb-5">
                    <div className="total-inline" hidden={sumaTotal(props.listaMetodoPago.listaFormaPagoOtros,1)==0}>
                        <label>Mov. Bancos</label>
                        <div>S/ {sumaTotal(props.listaMetodoPago.listaFormaPagoOtros,1)}</div>
                    </div>
                    <div className="total-inline"  hidden={sumaTotal(props.listaMetodoPago.listaFormaPagoOtros,2)==0}>
                        <label>Mov. Bancos</label>
                        <div>$ {sumaTotal(props.listaMetodoPago.listaFormaPagoOtros,2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline" hidden={sumaTotal(props.listaMetodoPago.listaFormaPago,1)==0}>
                        <label>Efectivo</label>
                        <div>S/ {sumaTotal(props.listaMetodoPago.listaFormaPago,1)}</div>
                    </div>
                    <div className="total-inline"  hidden={sumaTotal(props.listaMetodoPago.listaFormaPago,2)==0}>
                        <label>Efectivo</label>
                        <div>$ {sumaTotal(props.listaMetodoPago.listaFormaPago,2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline" hidden={sumaTotal(props.listaMetodoPago.listaFormaPagoCredito,1)==0}>
                        <label>Nota de credito</label>
                        <div>S/ {sumaTotal(props.listaMetodoPago.listaFormaPagoCredito,1)}</div>
                    </div>
                    <div className="total-inline" hidden={sumaTotal(props.listaMetodoPago.listaFormaPagoCredito,2)==0}>
                        <label>Nota de credito</label>
                        <div>$ {sumaTotal(props.listaMetodoPago.listaFormaPagoCredito,2)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}